import FormContact from "../../Forms/ContactForm";
import FormCarriere from "../../Forms/Carriere";

type FormsProps = {
  model: string;
  formJobsOptions?: { title: string; slug: string }[];
  formFieldsMap?: any;
  formID: number;
};

function Form({ model, formJobsOptions, formFieldsMap, formID }: FormsProps) {
  return (
    <>
      {model === "contact" ? (
        <FormContact formFieldsMap={formFieldsMap} formID={formID} />
      ) : model === "carriere" ? (
        <FormCarriere
          formJobsOptions={formJobsOptions}
          formFieldsMap={formFieldsMap}
          formID={formID}
        />
      ) : null}
    </>
  );
}

export default Form;
